import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Platform } from "@ionic/angular";
import * as $ from "jquery";
import { GlobalsService } from "src/app/api/globals.service";
import { StorageService } from "src/app/services/storage.service";
import { TimerService } from "src/app/services/timer.service";

@Component({
  selector: "app-sopa-letras",
  templateUrl: "./sopa-letras.component.html",
  styleUrls: ["./sopa-letras.component.scss"],
})
export class SopaLetrasComponent implements OnInit {
  @Input() public curso: any;
  @Input() public DATA: any;
  @Input() public OPCIONES: any;
  @Input() public ID_TIPO_LC: any;
  @Output() public isvalid = new EventEmitter<boolean>();
  @Output() public name = new EventEmitter<string>();
  puzzleObj: any = [];
  dataPuzzle: any = [];
  public activityCourse: any;
  private ID_TIPO = 6;
  private ID_ACTIVIDAD = 0;
  public explicacion: string = "";
  sqliteStorage: boolean = false;
  sqliteStorageData: any = null;
  inicio_actividad_key: string;
  inicio_actividad_res_key: string;
  constructor(
    private storageService: StorageService,
    private platform: Platform,
    public globalsService: GlobalsService,
    private timerService: TimerService
  ) {
    this.ismobile = globalsService.isMobile;
  }
  posiciones: any = [
    "horizontal",
    "horizontalR",
    "vertical",
    "verticalR",
    "diagonalD",
    "diagonalDR",
    "diagonalU",
    "diagonalUR",
  ];
  minWidth: number;
  ismobile: boolean;
  puzzleMin: any = { y: 5, x: 5 };
  flagOpen: string = "";
  flagOpenTemp: string = "";
  word: string = "";
  flagClosed: string = "";
  codigos: any = [];

  private readonly table = "actividades_respuestas_data";
  ngOnInit() {
    this.name.emit("Sopa de Letras");
    console.log("DATA sopa: ", this.DATA);
    this.ID_ACTIVIDAD = this.DATA.id_actividad;
    let _id_librocurso = this.ID_ACTIVIDAD;
    let id_tipo = this.ID_TIPO;
    let id_ejercicio = this.DATA.id;
    let _id_curso = this.curso.id;
    let _tipo = this.ID_TIPO_LC;
    let _id_user = this.curso.id_user;
    this.storageService.AskItems = this.OPCIONES.length;
    const keyFK = `inicio_actividad_${_id_curso}_${_id_librocurso}_${_id_user}_${_tipo}`;
    console.log("DATA ->keyFK:", keyFK);
    this.inicio_actividad_res_key = keyFK;
    const key = `inicio_actividad_${_id_curso}_${_id_librocurso}_${_id_user}_${_tipo}_${id_ejercicio}_${id_tipo}`;
    console.log("DATA ->KEY:", key);
    this.inicio_actividad_key = key;
    this.platform.ready().then(() => {
      this.getStorage();
    });
  }
  palabras: any;
  construirPuzzle() {
    this.palabras = this.OPCIONES;
    let palabras = this.palabras;
    console.log("palabras: ", palabras);
    let len = palabras.length + 2;
    palabras.forEach((element, i) => {
      let p = element.palabra;
      if (p.length + 2 > len) {
        len = p.length + 2;
      }

      let arr = element.codigo.split(",");
      let pal = element.palabra.split("");
      if (
        element.tipo == "verticalR" ||
        element.tipo == "horizontalR" ||
        element.tipo == "diagonalDR"
      ) {
        pal = pal.reverse();
      }
      let abjeto: any = [];
      pal.forEach((letra, j, array) => {
        let a = arr[j];
        abjeto.push({ letra: letra, code: a });
      });
      this.dataPuzzle.push(abjeto);
    });
    console.log("dataPuzzle: ", this.dataPuzzle);
    this.puzzleMin = { y: len, x: len };
    console.log("Tamaño maximo: ", this.puzzleMin);
    this.minWidth = 46 * len + 30;

    for (let i = 0; i < this.puzzleMin.y; i++) {
      let idY = this.pad(i, 2);
      this.puzzleObjData.push({ idX: [] });
      this.puzzleObj.push({ idY: idY, idX: [] });
      for (let j = 0; j < this.puzzleMin.x; j++) {
        let idX = this.pad(j, 2);
        let id_col = "";
        id_col = "r" + idY + "_c" + idX;
        let w = this.randomLetter(1);
        let code = "";
        this.dataPuzzle.forEach((elA) => {
          elA.forEach((elB) => {
            if (elB.code == "#" + id_col) {
              w = elB.letra;
              code = "#" + id_col;
            }
          });
        });
        let find = false;
        this.palabrasEncontradas.forEach((element) => {
          if (code && element.codigo.includes(code)) {
            find = true;
          }
        });
        this.puzzleObjData[i].idX.push({ letter: w, find: find, code: code });
        this.puzzleObj[i].idX.push(idX);
      }
      if (i == this.puzzleMin.y - 1) {
        console.log("puzzleObj: ", this.puzzleObj);
      }
    }
  }
  puzzleObjData: any = [];
  randomLetter(length) {
    var result = "";
    var characters = "aábcdeéfghiíjklmnñoópqrstuvwxyz";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  setPuzzle(id) {
    let letra = "";
    this.dataPuzzle.forEach((element) => {
      element.forEach((el) => {
        if (id == el.code) {
          letra = el.letra;
        }
      });
    });
    return letra;
  }
  pad(str, max) {
    str = str.toString();
    return str.length < max ? this.pad("0" + str, max) : str;
  }

  mdown: boolean = false;
  mousedown(id) {
    if (this.mdown && this.ismobile) {
      return;
    }
    let _this = $("#" + id);
    this.flagOpen = "";
    let flagClosed = "";
    this.word = "";
    this.flagOpenTemp = "";
    this.flagOpen = $(_this).attr("id");
    if (this.word == "") this.word = $.trim($(_this).text());
    this.flagOpenTemp = this.flagOpen;
    console.log("Open: ", this.flagOpen);
    $(".p-caja").removeClass("selected");
  }

  // Métodos para soporte touch
  touchstart(event, id) {
    event.preventDefault();
    this.mousedown(id);
  }

  touchmove(event) {
    event.preventDefault();
    // Obtener el elemento bajo el dedo
    let touch = event.touches[0];
    let elem = document.elementFromPoint(touch.clientX, touch.clientY);
    if (elem && elem.id && elem.classList.contains('p-caja')) {
      this.mouseover(elem.id);
    }
  }

  touchend(event, id) {
    event.preventDefault();
    this.mouseup(id);
  }
  palabrasEncontradas: any = [];
  verificarSeleccion(codigos: any) {
    console.log("verificarSeleccion!!!: ", codigos);
    let codigo: any;
    this.palabras.forEach((element) => {
      codigo = element.codigo.split(",");
      console.log("palabras!!!: ", codigo);
      if (JSON.stringify(codigo) == JSON.stringify(codigos)) {
        console.log("encontrada!!!: ", element.palabra);

        if (this.palabrasEncontradas.length > 0) {
          if (
            !this.palabrasEncontradas.find((x) => x.palabra === element.palabra)
          ) {
            this.palabrasEncontradas.push({
              palabra: element.palabra,
              codigo: element.codigo,
            });
          }
        } else {
          this.palabrasEncontradas.push({
            palabra: element.palabra,
            codigo: element.codigo,
          });
        }

        //this.puzzleObjData[i].idX.push({letter:w,find:false});
        codigos.forEach((elH) => {
          this.puzzleObjData.forEach((pbd) => {
            //console.log('pbd: ',pbd.idX);

            pbd.idX.forEach((x) => {
              if (x.code == elH) {
                x.find = true;
                //console.log('find: ',x);
              }
            });
          });
          //$(elH).addClass('find');
          //this.puzzleObjData[x].idX[y].find
        });
      } else if (JSON.stringify(codigo) == JSON.stringify(codigos.reverse())) {
        console.log("encontrada!!!!: ", element.palabra);
        //console.log('palabrasEncontradas: ',this.palabrasEncontradas.find(x => x.palabra === element.palabra));
        if (this.palabrasEncontradas.length > 0) {
          if (
            !this.palabrasEncontradas.find((x) => x.palabra === element.palabra)
          ) {
            this.palabrasEncontradas.push({
              palabra: element.palabra,
              codigo: element.codigo,
            });
          }
        } else {
          this.palabrasEncontradas.push({
            palabra: element.palabra,
            codigo: element.codigo,
          });
        }
        codigos.forEach((elH) => {
          this.puzzleObjData.forEach((pbd) => {
            pbd.idX.forEach((x) => {
              if (x.code == elH) {
                x.find = true;
              }
            });
          });
        });
      }
    });
    this.buscarObjetosPorPropiedad();
    console.log("palabrasEncontradas: ", this.palabrasEncontradas);
    this.Storage(this.palabrasEncontradas);
  }

  buscarObjetosPorPropiedad() {
    var encontradas = this.palabras.filter((obj1) =>
      this.palabrasEncontradas.some((obj2) => obj1.palabra === obj2.palabra)
    );

    if (this.palabras.length == encontradas.length) {
      console.log("Todas las palabras encontradas");
      this.isvalid.emit(true);
    }
  }

  checkWord(palabra: string) {
    let find = false;
    this.palabrasEncontradas.forEach((element) => {
      if (element.palabra == palabra) {
        find = true;
      }
    });

    return find;
  }
  mouseup(id) {
    if (!this.mdown && this.ismobile) {
      this.mdown = true;
      console.log("mouseup: ");
      return;
    }

    if (this.flagOpen != "") {
      this.flagClosed = "";
      this.flagClosed = $("#" + id).attr("id");
      console.log("close: ", this.flagClosed);
      let open = this.flagOpen.split("_");
      let openR = parseInt(open[0].replace("r", ""));
      let openC = parseInt(open[1].replace("c", ""));

      let close = this.flagClosed.split("_");
      let closeR = parseInt(close[0].replace("r", ""));
      let closeC = parseInt(close[1].replace("c", ""));
      console.log("Word: ", this.word);
      console.log("codigos: ", this.codigos);

      this.verificarSeleccion(this.codigos);
      this.mdown = false;
      this.codigos = [];
      $(".p-caja").removeClass("selected");
      this.flagOpen = "";
      this.flagOpenTemp = "";
      this.flagClosed = "";
      if (this.word != "") {
        this.word = "";
      }
    }
  }
  mouseover(id) {
    if (this.flagOpen != "") {
      if (!this.diagonalDU("#" + id)) {
        if (!this.diagonalUD("#" + id)) {
          if (!this.horizontalNormal("#" + id)) {
            this.verticarNormal("#" + id);
          }
        }
      }
    }
  }
  diagonalDU(element) {
    console.log("diagonalDU");
    let str = $(element).attr("id");
    var res = str.split("_");
    let open = this.flagOpenTemp.split("_");
    let openR = parseInt(open[0].replace("r", ""));
    let openC = parseInt(open[1].replace("c", ""));
    let r = parseInt(res[0].replace("r", ""));
    let c = parseInt(res[1].replace("c", ""));
    let r1 = r - openR;
    let c1 = openC + r1;
    //console.log('r1: ' + r1 + ' / c1: ' + c1);
    this.word = "";
    if (c1 == c) {
      if (r1 < 0) {
        this.codigos = [];
        console.log("Diagonal inversa");
        $(".p-caja").removeClass("selected");
        $("input").removeClass("selected");
        for (let i = 0; i <= r1 * -1; i++) {
          let clase =
            "#r" + this.pad(openR - i, 2) + "_c" + this.pad(openC - i, 2);
          //console.log(clase);
          $(clase).addClass("selected");
          $(clase + "i").addClass("selected");
          this.codigos.push(clase);
          this.word += $.trim($(clase).text());
        }
      } else {
        //console.log('Diagonal normal');
        this.codigos = [];
        $(".p-caja").removeClass("selected");
        $("input").removeClass("selected");
        for (let i = 0; i <= r1; i++) {
          let clase =
            "#r" + this.pad(openR + i, 2) + "_c" + this.pad(openC + i, 2);
          $(clase).addClass("selected");
          $(clase + "i").addClass("selected");
          this.codigos.push(clase);
          this.word += $.trim($(clase).text());
        }
      }
      return true;
    } else {
      return false;
    }
  }
  diagonalUD(element) {
    let str = $(element).attr("id");
    var res = str.split("_");
    let open = this.flagOpenTemp.split("_");
    let openR = parseInt(open[0].replace("r", ""));
    let openC = parseInt(open[1].replace("c", ""));
    let r = parseInt(res[0].replace("r", ""));
    let c = parseInt(res[1].replace("c", ""));
    let c1 = c - openC;
    let r1 = openR - r;
    if (c1 == r1) {
      if (c1 < 0) {
        this.word = "";
        this.codigos = [];
        $(".p-caja").removeClass("selected");
        $("input").removeClass("selected");
        for (let i = 0; i <= r1 * -1; i++) {
          let clase =
            "#r" + this.pad(openR + i, 2) + "_c" + this.pad(openC - i, 2);
          $(clase).addClass("selected");
          $(clase + "i").addClass("selected");
          this.codigos.push(clase);
          this.word += $.trim($(clase).text());
        }
      } else {
        this.word = "";
        this.codigos = [];
        $(".p-caja").removeClass("selected");
        $("input").removeClass("selected");
        for (let i = 0; i <= r1; i++) {
          let clase =
            "#r" + this.pad(openR - i, 2) + "_c" + this.pad(openC + i, 2);
          $(clase).addClass("selected");
          $(clase + "i").addClass("selected");
          this.codigos.push(clase);
          this.word += $.trim($(clase).text());
        }
      }
      return true;
    } else {
      return false;
    }
  }

  horizontalNormal(element) {
    console.log("horizontalNormal");
    let str = $(element).attr("id");
    let res = str.split("_");
    let open = this.flagOpenTemp.split("_");
    let openR = parseInt(open[0].replace("r", ""));
    let openC = parseInt(open[1].replace("c", ""));
    let r = parseInt(res[0].replace("r", ""));
    let c = parseInt(res[1].replace("c", ""));
    let r1 = r - openR;
    let c1 = c;
    if (openR == r) {
      if (openC < c) {
        console.log("horizontalNormal");
        this.word = "";
        this.codigos = [];
        $(".p-caja").removeClass("selected");
        $("input").removeClass("selected");
        for (let i = 0; i <= c - openC; i++) {
          let clase = "#r" + this.pad(openR, 2) + "_c" + this.pad(openC + i, 2);
          $(clase).addClass("selected");
          $(clase + "i").addClass("selected");
          this.codigos.push(clase);
          this.word += $.trim($(clase).text());
        }
      } else {
        this.codigos = [];
        console.log("horizontal reversa");
        $(".p-caja").removeClass("selected");
        $("input").removeClass("selected");
        for (let i = openC; i >= c1; i--) {
          let clase = "#r" + this.pad(openR, 2) + "_c" + this.pad(i, 2);
          $(clase).addClass("selected");
          $(clase + "i").addClass("selected");
          this.codigos.push(clase);
          this.word += $.trim($(clase).text());
        }
      }
      return true;
    }
    return false;
  }
  verticarNormal(element) {
    let str = $(element).attr("id");
    var res = str.split("_");
    let open = this.flagOpenTemp.split("_");
    let openR = parseInt(open[0].replace("r", ""));
    let openC = parseInt(open[1].replace("c", ""));
    let r = parseInt(res[0].replace("r", ""));
    let c = parseInt(res[1].replace("c", ""));
    //console.log( 'openR: ' + (openR) + ' | openC: ' + (openC) );
    let r1 = r - openR;
    let c1 = c;
    console.log("r: " + r + " / c: " + c1);
    if (openC == c) {
      if (openR < r) {
        console.log("Vertical normal", this.palabras);
        this.codigos = [];
        this.word = "";
        $(".p-caja").removeClass("selected");
        $("input").removeClass("selected");
        for (let i = 0; i <= r - openR; i++) {
          let clase = "#r" + this.pad(openR + i, 2) + "_c" + this.pad(openC, 2);
          console.log("clase: ", clase);
          $(clase).addClass("selected");
          $(clase + "i").addClass("selected");
          this.codigos.push(clase);
          this.word += $.trim($(clase).text());
          console.log("Clase v: ", this.codigos);
        }
      } else {
        this.codigos = [];
        this.word = "";
        $(".p-caja").removeClass("selected");
        $("input").removeClass("selected");
        console.log("Vertical reverso");
        $(".p-caja").removeClass("selected");
        for (let i = openR; i >= r; i--) {
          let clase = "#r" + this.pad(i, 2) + "_c" + this.pad(openC, 2);
          $(clase).addClass("selected");
          $(clase + "i").addClass("selected");
          this.codigos.push(clase);
          this.word += $.trim($(clase).text());
        }
      }
      return true;
    }
    return false;
  }

  Storage(respuesta: any) {
    this.storageService
      .get("activities")
      .then((res) => {
        if (res) {
          this.activityCourse = res;
          //let data:any = this.activityCourse.data;
          this.activityCourse.forEach((element, i) => {
            let find: boolean = false;
            //console.log("DATA:",this.DATA.id_tipo);
            if (
              element.id == this.curso.id &&
              element.id_actividad == this.ID_ACTIVIDAD
            ) {
              find = true;

              let data: any;
              data = {
                itemLength: this.OPCIONES.length,
                id: this.DATA.id,
                id_actividad: this.DATA.id_actividad,
                id_tipo: this.DATA.id_tipo,
                respuesta: {
                  r: respuesta,
                },
              };
              if (element.data.length == 0) {
                element.data.push(data);
              } else {
                let find: boolean = false;
                element.data.forEach((element2, j) => {
                  if (
                    element2.id_tipo == this.DATA.id_tipo &&
                    element2.id == this.DATA.id
                  ) {
                    element.data[j] = data;
                    find = true;
                  }
                });
                if (!find) {
                  element.data.push(data);
                }
              }
            }
          });
          this.storageService.storage("activities", this.activityCourse);
        } else {
          this.storageService.storage("activities", this.activityCourse);
        }
      })
      .catch((err) => {
        console.log("storageService error", err);
      });
    /************************************* */
  }

  async getStorage() {
    let activityCourse: any;
    this.ID_ACTIVIDAD;
    this.storageService.get("activities").then((res: any) => {
      if (res) {
        activityCourse = res.find(
          (x) => x.id_actividad == this.ID_ACTIVIDAD && x.id == this.curso.id
        );
        activityCourse.data.forEach((element2, j) => {
          if (
            element2.id == this.DATA.id &&
            element2.id_actividad == this.ID_ACTIVIDAD &&
            element2.id_tipo == this.ID_TIPO
          ) {
            let respuestas = element2;
            this.palabrasEncontradas = respuestas.respuesta.r;
            this.isvalid.emit(true);
          }
        });
        this.construirPuzzle();
      } else {
        this.construirPuzzle();
      }
      this.buscarObjetosPorPropiedad();
    });
  }
  /************************* */
  showWord(code: string, find: boolean, i) {
    if (!find) {
      return;
    }
    let highlights = "selected";
    let allWords = "p-caja";
    let elemAW: any = document.getElementsByClassName(allWords);
    for (let j = 0; j < elemAW.length; j++) {
      $(elemAW[j]).removeClass(highlights);
    }
    let codeArray: any = code.split(",");
    codeArray.forEach((element) => {
      $(element).addClass(highlights);
    });
  }
}
